import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'
import { AuthenticatedStorefrontAPIRequest, StorefrontApiResponse } from 'components/discovery/shared/ecommerce-api-token/api/ecommerce-api-token-api.js'
import { fetchAuthenticated } from 'components/discovery/shared/ecommerce-api-token/api/authenticated-request.js'
import type { OrderHistory } from 'components/discovery/pdp/order-history/typing/order-history-types.js'

export class GetOrderHistoryRequest extends AuthenticatedStorefrontAPIRequest { }

export interface OrderHistoryAPI {
  getOrderHistory(request: GetOrderHistoryRequest): StorefrontApiResponse<OrderHistory>
}

export class FakeOrderHistoryAPI implements OrderHistoryAPI {
  orderHistoryRequests: GetOrderHistoryRequest[] = []
  orderHistoryData: OrderHistory | null = null
  throws: Error | null = null

  shouldResolveInstantly: boolean = true
  resolveResponse!: () => void
  private responsePromise: Promise<void> = new Promise(resolve => this.resolveResponse = resolve)

  async getOrderHistory(request: GetOrderHistoryRequest) {
    this.orderHistoryRequests.push(request)

    if (!this.shouldResolveInstantly) {
      await this.responsePromise
      this.responsePromise = new Promise(resolve => this.resolveResponse = resolve)
    }

    if (this.throws) return Promise.reject(this.throws)
    return Promise.resolve(this.orderHistoryData as OrderHistory)
  }
}

export class RealOrderHistoryAPI implements OrderHistoryAPI {
  getOrderHistory(request: GetOrderHistoryRequest) {
    return fetchAuthenticated<OrderHistory>(request)
  }
}

export let orderHistoryApi!: OrderHistoryAPI
registerDependency({
  [REAL]: () => orderHistoryApi = new RealOrderHistoryAPI(),
  [FAKE]: () => orderHistoryApi = new FakeOrderHistoryAPI(),
})
